import { PhoneFilled, PushpinFilled } from "@ant-design/icons";
import { Card, Col, Row, Typography } from "antd";
import React from "react";

const CardDefault = ({
  qrCodeRef,
  logo,
  profile,
  candidateName,
  mobile,
  studentAdmission,
  studentClass,
  studentSection,
  displayNumber,
  qrData,
  company,
}) => {
  return (
    <Card
      style={{
        width: 300,
        textAlign: "center",
        borderRadius: 12,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
        // paddingTop: 20,
        paddingRight: 20,
        paddingLeft: 20,
        paddingBottom: 10,
        backgroundColor: "#f9f9f9",
        border: "1px solid #ddd",
      }}
      ref={qrCodeRef}
    >
      {/* <h5
        style={{
          marginBottom: "15px",
          fontSize: "18px",
          fontWeight: "bold",
          boxShadow: "0 0 4px 2px rgb(219, 219, 219)",
          backgroundColor: "#a6cc43",
          color: "white",
          padding: "10px",
          borderRadius: "8px",
        }}
      >
        {company.name}
      </h5> */}
      <h5
        style={{
          marginBottom: "0px",
          fontSize: "24px",
          fontWeight: "bold",
          // boxShadow: "0 0 4px 2px rgb(235, 234, 234)",
          backgroundColor: "transparent",
          // color: "white",
          padding: "2px 0px",
          marginTop: "8px",
          borderRadius: "8px",
        }}
      >
        {company.name}
        <br />
        <span style={{ fontWeight: "lighter", fontSize: 18 }}>
          <PhoneFilled /> {company.mobile}
        </span>
      </h5>

      <Row style={{ marginTop: 10 }} justify="space-between" align="middle">
        <Col span={12} style={{ textAlign: "center" }}>
          <img src={logo} width={90} alt="Logo" />
        </Col>
        <Col span={12} style={{ textAlign: "center" }}>
          <img src={qrData} width={80} alt="QR Code" />
        </Col>
      </Row>
      {/* <div style={{ display: "flex", justifyContent: "center" }}>
        <img
          src={logo}
          alt="Profile"
          style={{
            width: 120,
            height: 120,
            // borderRadius: "50%",
            objectFit: "cover",
            // border: "4px solid #a6cc43",
          }}
        />
      </div> */}

      {/* <Typography.Title level={4} style={{ marginTop: 15, color: "#333" }}>
        {candidateName}
      </Typography.Title> */}

      {/* {studentClass && studentSection && (
        <Typography.Text strong style={{ fontSize: 16, color: "#666" }}>
          Class: {studentClass} | Section: {studentSection} | Admission No{" "}
          {studentAdmission}
        </Typography.Text>
      )} */}

      <div
        style={{
          background: "#a6cc43",
          color: "white",
          padding: "8px 15px",
          borderRadius: 8,
          marginTop: 15,
          fontWeight: "bold",
          fontSize: 16,
        }}
      >
        {displayNumber}
      </div>

      <Row style={{ marginTop: 20, marginBottom: 15 }} justify="space-between" align="middle">
        <Col span={12} style={{ textAlign: "center" }}>
          <img
            src={profile}
            width={90}
            alt="QR Code"
            style={{
              borderRadius: "50%",
              objectFit: "cover",
              border: "4px solid #a6cc43",
            }}
          />
        </Col>
        <Col span={12} style={{ textAlign: "center" }}>
          {/* <img src={logo} width={120} alt="Logo" /> */}
          <div>
            <Typography.Text>{candidateName}</Typography.Text>
            <br />
            <Typography.Text>
              <PhoneFilled /> {mobile}
            </Typography.Text>
            <br />
            {studentClass && studentSection && (
              <Typography.Text>
                {studentClass} - {studentSection}
              </Typography.Text>
            )}
          </div>
        </Col>
      </Row>

      {company.address && (
        <Typography.Text style={{ fontSize: 12 }}>
          {company.address}
        </Typography.Text>
      )}
    </Card>
  );
};

export default CardDefault;
